/**
 * Produces both `duration_ms` and `duration_seconds` from a raw millisecond
 * value. Use this in every duration-emitting Amplitude event to ensure
 * consistent units across all analytics.
 */
export const durationProps = (ms: number) => {
  const duration_ms = Math.round(ms);
  return {
    duration_ms,
    duration_seconds: Math.round(duration_ms / 1000),
  };
};
